import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/marital-status.png'

const DemographicsMaritalStatus = dynamic(() => import('src/components/insights/demographics/cards/marital-status'), {
  ssr: false,
})

export const DemographicsMaritalStatusWidget: InsightBuilderWidget = {
  id: 'marital-status',
  name: 'Marital Status',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsMaritalStatus,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
